import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Badge,
  Breadcrumb,
  Card,
  Col,
  Container,
  Row,
  Form,
  Modal,
  Spinner
} from "react-bootstrap";

import {
  CustomPaging,
  EditingState,
  PagingState,
  SearchState,
  SortingState,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
  TableEditColumn,
  Toolbar,
  SearchPanel
} from '@devexpress/dx-react-grid-bootstrap4';

import {Loading} from 'components/Loading/loading';
import PopupEditing from 'components/ReactTable/PopupEditing.js';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import Popup from './Popup.js';

const SORT_FIELD_MAP = {
  name: 'employee.EMP_NAME',
  email: 'employee.EMP_EMAIL',
}

export default function Index() {

  const [swal, setSwal] = useAlert();
  const [columns] = useState([
    { name: 'USER_ID', title: 'ID' },
    { name: 'name', title: 'Name', getCellValue: row => (row.employee) ? row.employee.EMP_NAME : `n-a` },
    { name: 'email', title: 'Email', getCellValue: row => (row.employee) ? row.employee.EMP_EMAIL : `n-a` },
    { name: 'status', title: 'Status', getCellValue: row => row.USER_STATUS
      ? <Badge variant="primary">Active</Badge>
      : <Badge variant="secondary">Deactived</Badge>
    }
  ]);

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [pageSizes] = useState([5, 10, 15]);
  const [searchValue, setSearchValue] = useState('');
  const [message, setMessage] = useState('');
  const [updated, setUpdated] = useState('');
  const [sorting, setSorting] = useState([{ columnName: 'USER_ID', direction: 'asc' }]);

  const commitChanges = async ({ added, changed, deleted }) => {

    try {

      if (added) {

        const newItem = {...added.pop()};
        const response = await axios.post(`${process.env.REACT_APP_API_HOST}users`, newItem);
        if (response.status !== 201) throw new Error(`Create new error`);

        setSwal({
          type: TYPES.SUCCESS,
          payload: {
            title: `Create Success`,
            message: `New user successfully created.`,
          }
        });

        return fetchData();
      }

      if (changed) {
        const id = Object.keys(changed).pop();
        const updatedItem = { ...changed[id] };
        const response = await axios.put(`${process.env.REACT_APP_API_HOST}users/${id}`, updatedItem);
        if (response.status !== 200) throw new Error('Update error');

        setSwal({
          type: TYPES.SUCCESS,
          payload: {
            title: `Update Success`,
            message: `User successfully updated.`,
          }
        });

        return fetchDataBu();
      }

      if (deleted) {
        const item = rows.find(row => row.USER_ID === [...deleted].pop());
        const onSuccessCallback = async () => {
          const response = await axios.delete(`${process.env.REACT_APP_API_HOST}users/${item.USER_ID}`);
          if (response.status !== 204) throw new Error('Update error');

          return fetchData();
        }

        setSwal({
          type: TYPES.CONFIRM,
          payload: {
            title: `Are you sure`,
            message: `You are about to delete "${item.employee.EMP_NAME}" user.`,
            onSuccess: {
              title: `Success`,
              message: `Delete Success`,
              callback: onSuccessCallback,
            }
          }
        });
      }

    } catch (error) {

      if (error.response) {
        return setSwal({
          type: TYPES.ERROR,
          payload: {
            title: error.toString(),
            message: error.response.data.pop().message,
          }
        });
      }

      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
     }

  };

  const handleChange = (event) => {
    setMessage(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setUpdated(event.target.value);
    }
  };

  const getRowId = row => row.USER_ID;

  const fetchData = async () => {

    try {
      setLoading(true);

      const orderBy = sorting?.[0];
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}users`, {
        params: {
          expand: 'employee,roles',
          page: currentPage + 1,
          'per-page': pageSize,
          'search': updated,
          sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
        }
      });

      if (response.status !== 200) throw new Error(`Fetch error`);

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);

      setLoading(false);

    } catch (error) {
      console.log(error)
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });

      setLoading(false);
    }
  }

  const fetchDataBu = async () => {
    setUpdated('')
    setMessage('');
    try {
      setLoading(true);

      const orderBy = sorting?.[0];
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}users`, {
        params: {
          expand: 'employee,roles',
          page: currentPage + 1,
          'per-page': pageSize,
          'search': '',
          sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
        }
      });

      if (response.status !== 200) throw new Error(`Fetch error`);

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);

      setLoading(false);

    } catch (error) {
      console.log(error)
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });

      setLoading(false);
    }
  }

  useEffect(fetchData, [updated, searchValue, pageSize, currentPage, sorting]);

  return (
    <>
      {swal}
      <Container fluid>
        {loading && (
          <div
            style={{
              position: 'fixed',
              zIndex: 1050,
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Spinner animation="border" variant="dark" style={{ width: '100px', height: '100px', borderWidth: '5px' }} />
          </div>
        )}
        <Breadcrumb>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Master
          </Breadcrumb.Item>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            User
          </Breadcrumb.Item>
          <Breadcrumb.Item aria-current="page" active>
            Index
          </Breadcrumb.Item>
        </Breadcrumb>

        {rows && (
          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title as="h4">User List</Card.Title>
                </Card.Header>
                <Card.Body>
                  {/* <input
                    type="text"
                    placeholder='Search...'
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                  /> */}
                  <Row>
                    <Col md="4"></Col>
                    <Col md="4"></Col>
                    <Col md="4">
                    <Form.Group md='15'>
                      <Form.Control
                        value={message}
                        style={{ width: 250  }}
                        type="text"
                        placeholder='Search...'
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                      />
                    </Form.Group>
                    </Col>
                  </Row>
                  <Grid
                    rows={rows}
                    columns={columns}
                    getRowId={getRowId}
                  >
                    {/* Ini saya comment untuk perbaikan searching di user */}
                    {/* <SearchState onKeyDown={handleKeyDown}/> */}

                    <SortingState
                      sorting={sorting}
                      onSortingChange={setSorting}
                    />

                    <PagingState
                      currentPage={currentPage}
                      onCurrentPageChange={setCurrentPage}
                      pageSize={pageSize}
                      onPageSizeChange={setPageSize}
                    />
                    <CustomPaging totalCount={totalCount} />
                    <EditingState
                      onCommitChanges={commitChanges}
                    />
                    <Table />
                    <TableHeaderRow showSortingControls />
                    <TableEditColumn
                      showAddCommand
                      showEditCommand
                      showDeleteCommand
                    />
                    <PagingPanel
                      pageSizes={pageSizes}
                    />
                    <PopupEditing popupComponent={Popup} />

                    <Toolbar />
                    {/* <SearchPanel /> */}
                    {loading && <Loading />}
                  </Grid>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </>
  )
}